module.exports = __webpack_public_path__ + "img/ccompany-honor-VOC-20241024.f5f755e4.jpg";